<!-- K00_02_003_組織検索画面（POPUP） -->
<template>
  <a-modal
    centered
    :title="title"
    :width="params.customGroupFlg && params.customGroupFlg == '1' ? 900 : 550"
    :visible="visible"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <template slot="footer">
      <a-button @click="handleClear" icon="close">{{ $t('disp.clear') }}</a-button>
      <a-button type="primary" @click="handleSubmit" icon="check">{{ $t('disp.btn.confirm') }}</a-button>
    </template>

    <div :class="params.customGroupFlg && params.customGroupFlg == '1' ? 'depart-wrapper' : ''">
      <div class="left" v-if="params.customGroupFlg && params.customGroupFlg == '1'">
        <a-input-search
          style="margin-bottom: 26px"
          v-model="searchText"
          :placeholder="placeholder"
          @search="onSearch"
          @change="onSearch"
          allowClear
        />

        <!-- <div class="title">
          <span>快捷筛选</span>
        </div> -->

        <div class="user-wrapper">
          <div>
            <dt>
              <span>默认组别：</span>
            </dt>
            <dd>
              <div class="group-wrapper-outer">
                <div
                  class="group-wrapper selected"
                  :class="['border-color-blue', funcFlg ? 'selected' : '']"
                  @click="handleDefaultClick('1')"
                >
                  <div
                    class="markColor"
                    style="background: linear-gradient(90deg, var(--color-blue-6), var(--color-blue-3))"
                  ></div>

                  <span style="letter-spacing: 1px">职能部门</span>

                  <!-- <a-checkbox :checked="funcFlg"></a-checkbox> -->
                </div>

                <a-popover placement="right">
                  <template slot="content">
                    <div style="max-width: 250px">{{ funcFlgText }}</div>
                  </template>
                  <a-icon type="more" />
                </a-popover>
              </div>
              <div class="group-wrapper-outer">
                <div
                  class="group-wrapper selected"
                  :class="['border-color-green', funcNoFlg ? 'selected' : '']"
                  @click="handleDefaultClick('2')"
                >
                  <div
                    class="markColor"
                    style="background: linear-gradient(90deg, var(--color-green-6), var(--color-green-3))"
                  ></div>

                  <span style="letter-spacing: 1px">大区</span>

                  <!-- <a-checkbox :checked="funcNoFlg"></a-checkbox> -->
                </div>

                <a-popover placement="right">
                  <template slot="content">
                    <div style="max-width: 250px">{{ funcNoFlgText }}</div>
                  </template>
                  <a-icon type="more" />
                </a-popover>
              </div>
            </dd>
          </div>

          <div>
            <dt style="margin-top: 30px">
              <span>自定义组别：</span>
            </dt>
            <dd>
              <div v-for="(group, index) in groupList" :key="index" class="group-wrapper-outer">
                <div
                  class="group-wrapper selected"
                  :class="[
                    'border-color-' + group.markColor,
                    selectedGroupIds.indexOf(group.id) >= 0 ? 'selected' : '',
                  ]"
                  @click="handleClick(group)"
                >
                  <div
                    class="markColor"
                    :class="group.markColor"
                    :style="
                      'background: linear-gradient(90deg, var(--color-' +
                      group.markColor +
                      '-6), var(--color-' +
                      group.markColor +
                      '-3));'
                    "
                  ></div>

                  <span style="letter-spacing: 1px">{{ group.groupName }}</span>

                  <!-- <a-checkbox :checked="selectedGroupIds.includes(group.id)" :value="group.id"></a-checkbox> -->
                </div>

                <a-popover placement="right">
                  <template slot="content">
                    <div style="max-width: 250px">{{ group.groupDepartNames }}</div>
                    <div style="display: flex; justify-content: flex-end; margin-bottom: -10px; margin-top: 10px">
                      <a-button type="primary" size="small" @click="$refs.CustomGroup.edit(group)">编辑</a-button>

                      <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => groupDelete(group.id)">
                        <a-button type="primary" size="small">删除</a-button>
                      </a-popconfirm>
                    </div>
                  </template>
                  <a-icon type="more" />
                </a-popover>
              </div>

              <div
                class="group-wrapper new"
                :class="groupList.length == 0 ? 'no-data' : ''"
                @click="$refs.CustomGroup.add()"
              >
                <a-icon type="plus" />
                <span>新增组别</span>
              </div>
            </dd>
          </div>
        </div>
      </div>
      <div :class="params.customGroupFlg && params.customGroupFlg == '1' ? 'right' : ''">
        <a-spin :spinning="loading">
          <a-alert v-if="!!searchRangeText" type="warning" style="margin-bottom: 10px; padding: 4px 15px 5px 15px">
            <span slot="message">
              <span>{{ $t('disp.searchRange') }}：</span>
              <span v-if="!!params.historyFrom" style="letter-spacing: 1px; font-weight: 500; color: green">{{
                params.historyFrom
              }}</span>
              <span> ～ </span>
              <span v-if="!!params.historyTo" style="letter-spacing: 1px; font-weight: 500; color: green">{{
                params.historyTo
              }}</span>
            </span>
          </a-alert>

          <a-input-search
            style="margin-bottom: 16px"
            v-model="searchText"
            :placeholder="placeholder"
            @search="onSearch"
            @change="onSearch"
            allowClear
            v-if="!params.customGroupFlg"
          />

          <a-empty v-show="treeData.length == 0" style="padding: 20px"></a-empty>
          <a-tree
            checkable
            :class="[params.searchFlg == '1' ? 'tree-no-divider' : '']"
            class="depart-tree-root-icon"
            :multiple="multiple"
            :treeData="treeData"
            :checkStrictly="true"
            :selectable="false"
            @check="onCheck"
            :checkedKeys="checkedKeys"
            :expandedKeys="expandedKeys"
            @expand="onExpand"
          >
            <span slot="hasSlot" slot-scope="{ title, delFlag }">
              <span v-if="delFlag == '1'" class="span-deleted" v-html="keywordsColorful(title, searchText)"></span>
              <span v-else v-html="keywordsColorful(title, searchText)"></span>
            </span>
          </a-tree>
        </a-spin>
      </div>
      <div
        v-if="params.customGroupFlg && params.customGroupFlg == '1'"
        style="position: absolute; right: 8px; top: 2px"
      >
        <span style="font-size: 13px">上下级关联选择<span style="margin: 0 8px 0 2px">:</span></span>
        <a-switch size="small" v-model="checkCascader" />
      </div>
    </div>
    <CustomGroup ref="CustomGroup" @emit="searchGroup"></CustomGroup>
  </a-modal>
</template>

<script>
import { getAction, postAction, deleteAction } from '@/api/manage'
import CustomGroup from './CustomGroup'

export default {
  name: 'SelectDepartTreeModal',
  // companyId   遷移パラメータ.会社ID
  // departName  遷移パラメータ.組織名
  // multiFlg    0：シングル選択、1：マルチ選択
  // departFlg   0：全組織 1：自会社 2：他会社 3：得意先 4：仕入先 5：グループ 6：グループ（自社抜き）
  // searchFlg   0: 組織、1:会社
  // historyFrom 過去データ検索用基準年月_開始（yyyy-MM）
  // historyTo   過去データ検索用基準年月_終了（yyyy-MM）
  props: {
    params: {
      type: Object,
    },
  },
  components: { CustomGroup },
  data() {
    return {
      loading: false,
      title: '',
      placeholder: '',
      searchText: '',
      visible: false,
      loading: false,
      autoExpandParent: true,
      checkCascader: true,
      treeData: [],
      checkedKeys: [],
      checkedRows: [],
      expandedKeys: [],
      searchValue: '',
      funcFlg: false,
      funcNoFlg: false,
      funcFlgText: false,
      funcNoFlgText: false,
      currentUserId: this.$getLoginUser().id,
      // 自定义组别
      groupList: [],
      selectedGroupIds: [],
      groupDeparts: [],
      url: {
        getDepartCompanyTree: '/blaze-sys/k00/k0002/DepartManage/getDepartCompanyTree',
        groupList: '/blaze-sys/sys/group/getGroupPageList',
        groupDelete: '/blaze-sys/sys/group/DepartManage/groupDelete',
      },
    }
  },
  mounted() {
    if (!this.params.multiFlg) this.params.multiFlg = '1'
    if (!this.params.departFlg) this.params.departFlg = '0'
    if (!this.params.searchFlg) this.params.searchFlg = '0'
    if (!this.params.customGroupFlg && this.params.departFlg == '1') this.params.customGroupFlg = '1'

    // 自定义组件表示
    if (this.params.customGroupFlg && this.params.customGroupFlg == '1') {
      // 默认自会社
      this.title = this.$t('disp.K0002003.title11')
      this.params.departFlg = '1'
    }

    this.searchText = this.params.departName

    this.loadDepart()

    // パラメータ.検索フラグ = 0:組織の場合
    if (this.params.searchFlg == '0') {
      this.placeholder = this.$t('disp.departNameLikeSearch')

      // ①パラメータ.組織フラグ = 0:全組織の場合
      // 画面タイトル_K0002003： 組織検索
      if (this.params.departFlg == '0') {
        this.title = this.$t('disp.K0002003.title0')
      }
      // ②パラメータ.組織フラグ = 1：自会社の場合
      // 画面タイトル_K0002003： 自会社組織検索
      else if (this.params.departFlg == '1') {
        this.title = this.$t('disp.K0002003.title1')
      }
      // ③パラメータ.組織フラグ = 2:他会社の場合
      // 画面タイトル_K0002003： 他会社組織検索
      else if (this.params.departFlg == '2') {
        this.title = this.$t('disp.K0002003.title2')
      }
      // ④パラメータ.組織フラグ = 3:得意先の場合
      // 画面タイトル_K0002003： 得意先組織検索
      else if (this.params.departFlg == '3') {
        this.title = this.$t('disp.K0002003.title3')
      }
      // ⑤パラメータ.組織フラグ = 4:仕入先の場合
      // 画面タイトル_K0002003： 仕入先組織検索
      else if (this.params.departFlg == '4') {
        this.title = this.$t('disp.K0002003.title4')
      }
      // ⑥パラメータ.組織フラグ = 5:グループの場合
      // 画面タイトル_K0002003： グループ組織検索
      else if (this.params.departFlg == '5') {
        this.title = this.$t('disp.K0002003.title5')
      }
      // ⑦パラメータ.組織フラグ = 6:グループ（自社抜き）の場合
      // 画面タイトル_K0002003： グループ組織検索（自社抜き）
      else if (this.params.departFlg == '6') {
        this.title = this.$t('disp.K0002003.title6')
      }
      // ⑦パラメータ.組織フラグ = 7:自社帳票差出拠点 & 他会社組織
      // 画面タイトル_K0002003： 組織検索
      else if (this.params.departFlg == '7') {
        this.title = this.$t('disp.K0002003.title0')
      }
    }

    // パラメータ.検索フラグ = 1:会社の場合
    if (this.params.searchFlg == '1') {
      this.placeholder = this.$t('disp.companyNameLikeSearch')

      // ①パラメータ.組織フラグ = 0:全組織の場合
      // 画面タイトル_K0002003： 会社検索
      if (this.params.departFlg == '0') {
        this.title = this.$t('disp.K0002003.title01')
      }
      // ②パラメータ.組織フラグ = 1：自会社の場合
      // 画面タイトル_K0002003： 自会社検索
      else if (this.params.departFlg == '1') {
        this.title = this.$t('disp.K0002003.title11')
      }
      // ③パラメータ.組織フラグ = 2:他会社の場合
      // 画面タイトル_K0002003： 他会社検索
      else if (this.params.departFlg == '2') {
        this.title = this.$t('disp.K0002003.title21')
      }
      // ④パラメータ.組織フラグ = 3:得意先の場合
      // 画面タイトル_K0002003： 得意先検索
      else if (this.params.departFlg == '3') {
        this.title = this.$t('disp.K0002003.title31')
      }
      // ⑤パラメータ.組織フラグ = 4:仕入先の場合
      // 画面タイトル_K0002003： 仕入先検索
      else if (this.params.departFlg == '4') {
        this.title = this.$t('disp.K0002003.title41')
      }
      // ⑥パラメータ.組織フラグ = 5:グループの場合
      // 画面タイトル_K0002003： グループ会社検索
      else if (this.params.departFlg == '5') {
        this.title = this.$t('disp.K0002003.title51')
      }
      // ⑦パラメータ.組織フラグ = 6:グループ（自社抜き）の場合
      // 画面タイトル_K0002003： グループ会社検索（自社抜き）
      else if (this.params.departFlg == '6') {
        this.title = this.$t('disp.K0002003.title61')
      }
    }
  },
  computed: {
    multiple() {
      if (this.params.multiFlg == '1') {
        return true
      } else {
        return false
      }
    },
    searchRangeText() {
      var text = '検索範囲：'
      if (this.params.historyFrom && this.params.historyTo) {
        return text + this.params.historyFrom + ' ～ ' + this.params.historyTo
      } else if (this.params.historyFrom) {
        return text + this.params.historyFrom + ' ～ '
      } else if (this.params.historyTo) {
        return text + ' ～ ' + this.params.historyTo
      } else {
        return ''
      }
    },
  },
  watch: {},
  methods: {
    async loadDepart() {
      var param = {}
      param.companyId = this.params.companyId
      param.departFlg = this.params.departFlg
      param.searchFlg = this.params.searchFlg
      param.historyFrom = this.params.historyFrom
      param.historyTo = this.params.historyTo
      param.searchText = this.searchText

      var that = this
      getAction(that.url.getDepartCompanyTree, param).then((res) => {
        if (res.success) {
          that.checkedRows = []
          if (that.params.selectedValue.length > 0) {
            that.checkedKeys = that.params.selectedValue
            that.params.selectedValue = []
          } else {
            that.checkedKeys = []
          }
          that.expandedKeys = []

          res.result.map((item) => that.setThisExpandedKeys(item))
          that.$nextTick(() => {
            that.treeData = res.result
            that.checkedRows = that.getCheckedRows(that.checkedKeys)
          })
        }
      })

      // 自定义组件
      if (this.params.customGroupFlg && this.params.customGroupFlg == '1') {
        // 部门明细取得
        this.groupDeparts = await this.$query('sys_depart', 'WHERE DEL_FLAG = 0')
        this.groupDeparts = XEUtils.orderBy(this.groupDeparts, [['OrgCode', 'asc']])

        // 职能部门
        this.funcFlgText = XEUtils.map(
          XEUtils.filter(this.groupDeparts, (r) => r.orgCategory == '4'),
          (departVo) => departVo.departName
        ).join(',')

        // 大区
        this.funcNoFlgText = XEUtils.map(
          XEUtils.filter(this.groupDeparts, (r) => r.orgCategory == '3'),
          (departVo) => departVo.departName
        ).join(',')

        await this.searchGroup()
        // check状态取得 取出缓存
        // if (localStorage['selectedDepartGroupIds' + this.currentUserId]) {
        //   var localeGroupData = XEUtils.toStringJSON(localStorage['selectedDepartGroupIds' + this.currentUserId])
        //   if (localeGroupData) {
        //     this.selectedGroupIds = XEUtils.get(localeGroupData, 'selectedGroupIds')
        //     this.funcFlg = XEUtils.get(localeGroupData, 'funcFlg')
        //     this.funcNoFlg = XEUtils.get(localeGroupData, 'funcNoFlg')
        //     // this.selectDepats()
        //   }
        // }
      }
    },
    setThisExpandedKeys(node) {
      if (this.params.departFlg == '3' && node.customersFlag != '1') {
        node.disableCheckbox = true
      }
      if (this.params.departFlg == '4' && node.supplierFlag != '1') {
        node.disableCheckbox = true
      }
      if (this.params.departFlg == '6' && node.groupFlag != '1') {
        node.disableCheckbox = true
      }
      if (node.children && node.children.length > 0) {
        // 有检索条件 或 检索自己公司的时候才展开 或 有companyId
        if (this.searchText || this.params.departFlg == '1' || this.params.companyId) {
          this.expandedKeys.push(node.id)
        }

        for (let i = 0; i < node.children.length; i++) {
          this.setThisExpandedKeys(node.children[i])
        }
      }
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    getChildrenKeys(currentKey, removeFlg) {
      var currentNode = XEUtils.filterTree(this.treeData, (item) => item.id == currentKey)
      if (currentNode) {
        if (removeFlg) {
          if (this.checkedKeys.includes(currentNode[0].id)) {
            XEUtils.remove(this.checkedKeys, (item) => item == currentNode[0].id)
          }
        } else {
          if (!this.checkedKeys.includes(currentNode[0].id)) {
            this.checkedKeys.push(currentNode[0].id)
          }
        }

        if (currentNode[0].children && currentNode[0].children.length > 0) {
          currentNode[0].children.forEach((child) => {
            this.getChildrenKeys(child.id, removeFlg)
          })
        }
      }
    },
    onCheck(checkedKeys, info) {
      if (this.params.multiFlg == '1') {
        // ・上位組織チェックすると、自動で全ての下位組織がチェックされる。
        // ・上位組織チェック外した場合は、自動で下位組織に対しては何もしない。
        if (info.checked == false) {
          // チェック済みから未チェックへの場合
          this.checkedKeys = checkedKeys.checked

          if (this.checkCascader) {
            // hong@2021-06-09 親組織でチェックを外したら子組織も全てチェック外すようにしてほしい(煙山)
            var currentKey = info.node.value
            var currentNode = XEUtils.filterTree(this.treeData, (item) => item.id == currentKey)
            if (currentNode[0].children && currentNode[0].children.length > 0) {
              this.getChildrenKeys(currentKey, true)
            }
          }
        } else {
          // 未チェックからチェック済みへの場合
          this.checkedKeys = checkedKeys.checked

          if (this.checkCascader) {
            var currentKey = info.node.value
            var currentNode = XEUtils.filterTree(this.treeData, (item) => item.id == currentKey)
            if (currentNode[0].children && currentNode[0].children.length > 0) {
              this.getChildrenKeys(currentKey)
            }
          }
        }
      } else {
        if (this.checkedKeys.includes(info.node.value)) {
          this.checkedKeys = []
        } else {
          this.checkedKeys = []
          this.checkedKeys.push(info.node.value)
        }
      }
      this.checkedRows = this.getCheckedRows(this.checkedKeys)
    },
    handleSubmit() {
      let list = []
      this.checkedRows.forEach((item) => {
        item.value = item.id
        item.text = item.departName
        item.children = null
        item.root = XEUtils.first(XEUtils.filter(this.treeData, (r) => r.orgCode == item.orgCode.substr(0, 3)))
        list.push(item)
      })
      // 缓存 记录
      // localStorage['selectedDepartGroupIds' + this.currentUserId] = XEUtils.toJSONString({
      //   selectedGroupIds: this.selectedGroupIds,
      //   funcFlg: this.funcFlg,
      //   funcNoFlg: this.funcNoFlg,
      // })
      this.$emit('emit', list)
      this.handleCancel()
    },
    handleCancel() {
      this.handleClear()
      this.visible = false
    },
    handleClear() {
      this.checkedKeys = []
      this.checkedRows = []
      // this.expandedKeys = []
      this.selectedGroupIds = []
      this.funcFlg = false
      this.funcNoFlg = false
      // if (type && type === 'clear') {
      //   // 缓存 清空
      //   localStorage.removeItem('selectedDepartGroupIds' + this.currentUserId)
      // }
    },
    onSearch() {
      this.loadDepart()
    },
    // checkedKeys により rows を取得
    getCheckedRows(checkedKeys) {
      const forChildren = (list, key) => {
        for (let item of list) {
          if (item.id === key) {
            return item
          }
          if (item.children instanceof Array) {
            let value = forChildren(item.children, key)
            if (value != null) {
              return value
            }
          }
        }
        return null
      }

      let rows = []
      for (let key of checkedKeys) {
        let row = forChildren(this.treeData, key)
        if (row != null) {
          rows.push(row)
        }
      }
      return rows
    },
    keywordsColorful(str, key) {
      var reg = new RegExp('(' + key + ')', 'g')
      var newStr = str.replace(reg, "<font style='background:#ff0;'>$1</font>")
      return newStr
    },
    handleClick(group) {
      this.checkDeparts(group.id)
      // this.selectedGroupIds = this.selectedGroupIds ? this.selectedGroupIds : []
      // if (this.selectedGroupIds.includes(group.id)) {
      //   XEUtils.remove(this.selectedGroupIds, (r) => r == group.id)
      // } else {
      //   this.selectedGroupIds.push(group.id)
      // }

      // // 去掉在groupList中不存在的groupId
      // XEUtils.remove(this.selectedGroupIds, (r) => !XEUtils.pluck(this.groupList, 'id').includes(r))

      // // 选中组织
      // this.selectDepats()
    },
    // 选中组织
    // 组别选择改为只进行追加选中
    checkDeparts(groupId) {
      var checkDepartIds = []

      if (groupId == 'funcFlg') {
        // 职能部门
        checkDepartIds = XEUtils.union(
          checkDepartIds,
          XEUtils.map(
            XEUtils.filter(this.groupDeparts, (r) => r.orgCategory == '4'),
            (departVo) => departVo.id
          )
        )
      } else if (groupId == 'funcNoFlg') {
        // 大区
        checkDepartIds = XEUtils.union(
          checkDepartIds,
          XEUtils.map(
            XEUtils.filter(this.groupDeparts, (r) => r.orgCategory == '3'),
            (departVo) => departVo.id
          )
        )
      } else if (groupId) {
        // 自定义组别
        var group = XEUtils.find(this.groupList, (r) => groupId == r.id)
        if (group) {
          checkDepartIds = XEUtils.union(
            checkDepartIds,
            XEUtils.map(group.groupDeparts, (r) => r.id)
          )
        }
      }

      this.checkedKeys = XEUtils.union(this.checkedKeys, checkDepartIds)
      this.checkedRows = this.getCheckedRows(this.checkedKeys)
    },
    // selectDepats() {
    //   var checkDepartIds = []
    //   if (this.funcFlg) {
    //     checkDepartIds = XEUtils.union(
    //       checkDepartIds,
    //       XEUtils.map(
    //         XEUtils.filter(this.groupDeparts, (r) => r.orgCategory == '4'),
    //         (departVo) => departVo.id
    //       )
    //     )
    //   }
    //   if (this.funcNoFlg) {
    //     checkDepartIds = XEUtils.union(
    //       checkDepartIds,
    //       XEUtils.map(
    //         XEUtils.filter(this.groupDeparts, (r) => r.orgCategory == '3'),
    //         (departVo) => departVo.id
    //       )
    //     )
    //   }

    //   if (this.selectedGroupIds && this.selectedGroupIds.length > 0) {
    //     this.selectedGroupIds.forEach((groupId) => {
    //       var group = XEUtils.find(this.groupList, (r) => groupId == r.id)
    //       if (group) {
    //         checkDepartIds = XEUtils.union(
    //           checkDepartIds,
    //           XEUtils.map(group.groupDeparts, (r) => r.id)
    //         )
    //       }
    //     })
    //   }
    //   this.checkedKeys = checkDepartIds
    //   this.checkedRows = this.getCheckedRows(this.checkedKeys)
    // },
    searchGroup() {
      return new Promise((resolve, reject) => {
        postAction(this.url.groupList, { pageNo: 1, pageSize: 999999999 }).then((res) => {
          if (res.success) {
            this.groupList = res.result ? res.result.records : []
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    groupDelete(groupId) {
      deleteAction(this.url.groupDelete, {
        id: groupId,
      }).then(async (res) => {
        if (res.success) {
          this.$message.success(this.$t(res.message))
          await this.searchGroup()
        }
      })
    },
    handleDefaultClick(type) {
      if (type === '1') {
        this.checkDeparts('funcFlg')
      }

      if (type === '2') {
        this.checkDeparts('funcNoFlg')
      }
    },
    // handleDefaultClick(type) {
    //   if (type === '1') {
    //     this.funcFlg = this.funcFlg ? false : true
    //   }

    //   if (type === '2') {
    //     this.funcNoFlg = this.funcNoFlg ? false : true
    //   }

    //   this.selectDepats()
    // },
  },
}
</script>

<style lang="less" scoped>
.ant-tree {
  > :global(li:first-child) {
    margin-top: -11px;
  }
}

span.span-deleted {
  text-decoration: line-through;
  color: #ccc;
}

.depart-wrapper {
  display: flex;
  position: relative;
  .left {
    width: 300px;
    background: white;
    padding: 0 30px 0 20px;

    .img-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 30px 20px;
    }

    .user-wrapper {
      dt {
        color: black;
        font-size: 15px;
        padding-left: 3px;
        padding-bottom: 4px;
        //font-weight: 700;
        text-shadow: 0 0 rgba(0, 0, 0, 50%);
      }

      dd {
        position: relative;

        /deep/ .j-input-popup-wrapper {
          .j-input-display {
            padding-left: 49px;
            line-height: 34px;
            color: black;
            background: linear-gradient(90deg, var(--color-blue-01), var(--color-blue-15));
          }

          input.j-input {
            height: 35px;
            line-height: 35px;
            border: none;
            box-shadow: none;

            &:hover {
              border-color: var(--color-blue-4);
            }
          }

          .i-search {
            margin-top: 1px;
            color: var(--color-blue-6);
          }
        }

        .ant-checkbox-wrapper {
          position: absolute;
          right: 1px;
          top: 8px;
        }

        .group-wrapper-outer {
          position: relative;

          &:hover {
            .anticon-more {
              opacity: 1;
            }
          }

          .anticon-more {
            color: rgba(0, 0, 0, 0.25);
            position: absolute;
            top: 4px;
            right: -24px;
            font-size: 28px;
            opacity: 0;
            transition: all 0.3s;
            cursor: pointer;
            transform: scaleY(0.84);

            &:hover {
              color: rgba(0, 0, 0, 0.85);
            }
          }
        }

        .group-wrapper {
          position: relative;
          border: 0px solid var(--color-input-border);
          height: 35px;
          line-height: 35px;
          margin-top: 1px;
          margin-bottom: 12px;
          padding: 0px 31px 0 48px;
          color: black;
          cursor: pointer;
          background: linear-gradient(90deg, #fbfbfb, #f8f8f8);
          transition: all 0.3s;
          z-index: 0;

          &:before {
            content: '';
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            transform: scaleX(0);
            transform-origin: 0 50%;
            transition-property: transform;
            transition-duration: 0s;
            transition-timing-function: ease-out;
          }

          /deep/ .ant-checkbox-checked:after {
            border: inherit;
          }

          /deep/ .ant-checkbox-input:focus + .ant-checkbox-inner,
          /deep/ .ant-checkbox:hover .ant-checkbox-inner {
            border: 1px solid #d9d9d9;
          }

          &.selected {
            &::before {
              transition-duration: 0.3s;
              transform: scaleX(1);
              transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
            }
          }

          &.border-color-blue {
            &::before {
              background: linear-gradient(90deg, var(--color-blue-01p), var(--color-blue-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-blue-6);
              background-color: var(--color-blue-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-blue-6);
            }
          }

          &.border-color-geek {
            &::before {
              background: linear-gradient(90deg, var(--color-geek-01p), var(--color-geek-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-geek-6);
              background-color: var(--color-geek-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-geek-6);
            }
          }

          &.border-color-green {
            &::before {
              background: linear-gradient(90deg, var(--color-green-01p), var(--color-green-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-green-6);
              background-color: var(--color-green-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-green-6);
            }
          }

          &.border-color-cyan {
            &::before {
              background: linear-gradient(90deg, var(--color-cyan-01p), var(--color-cyan-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-cyan-6);
              background-color: var(--color-cyan-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-cyan-6);
            }
          }

          &.border-color-yellow {
            &::before {
              background: linear-gradient(90deg, var(--color-yellow-01p), var(--color-yellow-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-yellow-6);
              background-color: var(--color-yellow-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-yellow-6);
            }
          }

          &.border-color-orange {
            &::before {
              background: linear-gradient(90deg, var(--color-orange-01p), var(--color-orange-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-orange-6);
              background-color: var(--color-orange-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-orange-6);
            }
          }

          &.border-color-red {
            &::before {
              background: linear-gradient(90deg, var(--color-red-01p), var(--color-red-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-red-6);
              background-color: var(--color-red-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-red-6);
            }
          }

          &.border-color-brown {
            &::before {
              background: linear-gradient(90deg, var(--color-brown-01p), var(--color-brown-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-brown-6);
              background-color: var(--color-brown-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-brown-6);
            }
          }

          &.border-color-pink {
            &::before {
              background: linear-gradient(90deg, var(--color-pink-01p), var(--color-pink-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-pink-6);
              background-color: var(--color-pink-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-pink-6);
            }
          }

          &.border-color-purple {
            &::before {
              background: linear-gradient(90deg, var(--color-purple-01p), var(--color-purple-2));
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              border-color: var(--color-purple-6);
              background-color: var(--color-purple-6);
            }

            .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
              border-color: var(--color-purple-6);
            }
          }

          .ant-badge {
            position: relative;
            left: -2px;
          }

          &.new {
            border: none;
            text-align: center;
            padding: 0;
            padding-right: 8px;
            color: var(--color-blue-6);
            transition: all 0.3s;
            border-radius: var(--border-radius);
            background: white;

            &.no-data {
              text-align: left;
              padding-left: 4px;
            }

            &:hover {
              color: var(--color-blue-8);
            }

            i {
              margin-right: 6px;
            }
          }
        }
      }
    }

    .right {
      width: calc(100% - 260px);
      background: white;
      padding: 0 20px;
      margin-left: 10px;
    }

    .markColor {
      position: absolute;
      width: 25px;
      height: 10px;
      z-index: 9;
      left: 11px;
      top: 12px;
      border-radius: 2px;
    }
  }
}
</style>
